export async function RedditPixelIdentifyUser(email: string) {
  if (process.env.REACT_APP_REDDIT_PIXEL_ID && (window as any).rdt) {
    (window as any).rdt("init", process.env.REACT_APP_REDDIT_PIXEL_ID, { email });
  }
}
